import { Component, Input, OnInit } from '@angular/core';
import { ResultData } from 'src/app/_models/ResultData';
import { GatePass } from './../../../_models/gate_pass';
import { LevelMinData } from './../../../_models/level_min_data';
import { AuthService } from './../../../_services/auth.service';
import { GuestService } from './../../../_services/guest.service';
import { SyllabusService } from './../../../_services/syllabus.service';

@Component({
  selector: 'app-level-info-display',
  templateUrl: './level-info-display.component.html',
  styleUrls: ['./level-info-display.component.css']
})

export class LevelInfoDisplayComponent implements OnInit {
  @Input() iData:any=undefined
  @Input() syllabusCode:string=undefined
  @Input() imageDescription:string=undefined

  @Input()  imageName:string=undefined
  imageFullPath:string=""
  @Input() gradeLevel:number=undefined
  primaryLevelNaming=undefined
  gatePass = new GatePass()
  public levelPrimaryOneInfo= new LevelMinData()


  constructor(
    private syllabusService:SyllabusService,
    public authService:AuthService,
    public guestService:GuestService) {

  }

  ngOnInit(): void {
    this.gatePass = this.authService.gatePass.getValue()
    this.levelThreeInfo()
    this.imageFullPath="/assets/images/level-info/"+this.imageName
  }
  levelThreeInfo(){
    this.syllabusService.levelInfo(this.syllabusCode).subscribe({
      next:(data:ResultData)=>{
        this.levelPrimaryOneInfo=data.rs.data
      },error:(err)=>{
        console.error("Error retrieving level syllabus",err)
      }

    })
  }

  downloadapp(){
    window.location.href = 'https://play.google.com/store/apps/details?id=com.boldungu.boldlet';
   }

}
